module.exports = __webpack_public_path__ + "img/trial.9e2e1b8d.png";